import { __assign } from "tslib";
import React, { forwardRef } from 'react';
import { CheckCardBase } from '../internal/CheckCardBase/CheckCardBase';
import { PureRadiobutton } from '../PureRadiobutton/PureRadiobutton';
export var RadiobuttonCard = forwardRef(function (props, ref) {
    return (React.createElement(CheckCardBase, __assign({}, props, { ref: ref, CheckComponent: PureRadiobutton })));
});
//# sourceMappingURL=RadiobuttonCard.js.map